import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { postAgeVerificationApi } from '@!/Api/ageVerification'
import { useAppCookies } from './useAppCookies'

// 年齢確認ダイアログの同意状態を扱う
// 同意時は記録の完了を待たずに同意済みとして扱い、記録に失敗した場合はcookieが残らないので次回アクセス時に改めて確認する
export const useAgeVerification = () => {
  const { ageVerificationConfirmedCookie } = useAppCookies()
  const [isAgeConfirmed, setIsAgeConfirmed] = useState(!!ageVerificationConfirmedCookie)

  const confirmAgeVerificationMutation = useMutation({
    mutationFn: () => postAgeVerificationApi(),
  })

  const confirmAgeVerification = () => {
    setIsAgeConfirmed(true)
    confirmAgeVerificationMutation.mutate()
  }

  return { isAgeConfirmed, confirmAgeVerification }
}
